var _path, _circle, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelcar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 29,
    viewBox: "0 0 27 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "avbryt bil",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92571 7.02515C4.04327 7.02515 3.3079 7.5867 3.02712 8.37555L0.246094 16.3844V27.0807C0.246094 27.816 0.847759 28.4177 1.58313 28.4177H2.92016C3.65553 28.4177 4.25719 27.816 4.25719 27.0807V25.7436H20.3016V27.0807C20.3016 27.816 20.9033 28.4177 21.6386 28.4177H22.9757C23.711 28.4177 24.3127 27.816 24.3127 27.0807V16.3844L22.6461 11.5848L19.9227 11.9231L20.5423 13.7103H4.00316L5.39367 9.69921H16.6933L15.6584 7.02515H4.92571ZM4.25719 19.727C4.25719 20.8367 5.15301 21.7325 6.26274 21.7325C7.37248 21.7325 8.2683 20.8367 8.2683 19.727C8.2683 18.6172 7.37248 17.7214 6.26274 17.7214C5.15301 17.7214 4.25719 18.6172 4.25719 19.727ZM16.2905 19.727C16.2905 20.8367 17.1863 21.7325 18.296 21.7325C19.4058 21.7325 20.3016 20.8367 20.3016 19.727C20.3016 18.6172 19.4058 17.7214 18.296 17.7214C17.1863 17.7214 16.2905 18.6172 16.2905 19.727Z",
    fill: "#016CC5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7649,
    cy: 6.67753,
    r: 5.03446,
    stroke: "#016CC5",
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.9014,
    y1: 7.1145,
    x2: 25.6288,
    y2: 7.1145,
    stroke: "#016CC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelcar);
export default __webpack_public_path__ + "static/media/cancelcar.635dca60.svg";
export { ForwardRef as ReactComponent };